"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.problemMap = void 0;
const Status_1 = require("../helpers/Status");
const ProblemCode_1 = require("./ProblemCode");
/**
 * Maps the standard ProblemCode to a `status` and optional default `detail`.
 *
 * The `detail` set here is a fallback, but it's recommended to override to a
 * more specific message at the point of the error being thrown, to provide
 * context of the specific error occurrence.
 *
 * The `detail` is intended for developers using the API, not for the end users
 * of the app.
 */
exports.problemMap = {
    [ProblemCode_1.ProblemCode.InternalServerError]: { status: Status_1.Status.InternalServerError },
    [ProblemCode_1.ProblemCode.AccountFeatureAccessDenied]: {
        status: Status_1.Status.Forbidden,
        detail: "The Account doesn't have access to the requested Feature.",
    },
    [ProblemCode_1.ProblemCode.UserAccountPermissionDenied]: {
        status: Status_1.Status.Forbidden,
        detail: "User does not have sufficient permission (role) on the account to perform the action.",
    },
    [ProblemCode_1.ProblemCode.ValidationFailed]: {
        status: Status_1.Status.BadRequest,
        detail: "Invalid request.",
    },
    [ProblemCode_1.ProblemCode.FieldRequired]: {
        status: Status_1.Status.BadRequest,
        detail: "Missing field.",
    },
    [ProblemCode_1.ProblemCode.FileRequired]: {
        status: Status_1.Status.BadRequest,
        detail: "Missing file attachment.",
    },
    [ProblemCode_1.ProblemCode.BadRequest]: {
        status: Status_1.Status.BadRequest,
        detail: "Invalid request.",
    },
    [ProblemCode_1.ProblemCode.ResourceNotFound]: {
        status: Status_1.Status.NotFound,
        detail: "Resource could not be found.",
    },
    [ProblemCode_1.ProblemCode.TransactionInvalid]: {
        status: Status_1.Status.BadRequest,
        detail: "The resulting event / transaction failed validation.",
    },
    [ProblemCode_1.ProblemCode.Unauthorised]: {
        status: Status_1.Status.Unauthorized,
        detail: "Authentication failed.",
    },
    [ProblemCode_1.ProblemCode.Forbidden]: {
        status: Status_1.Status.Forbidden,
        detail: "You don't have access to do this.",
    },
    [ProblemCode_1.ProblemCode.RefreshedExpiredOtp]: { status: Status_1.Status.NotFound },
    [ProblemCode_1.ProblemCode.EmailRegistrationExpired]: { status: Status_1.Status.NotFound },
    [ProblemCode_1.ProblemCode.VerifiedUserAlreadyExists]: { status: Status_1.Status.NotFound },
    [ProblemCode_1.ProblemCode.GoogleAuthFailed]: { status: Status_1.Status.Unauthorized },
    [ProblemCode_1.ProblemCode.EmailDisallowed]: {
        status: Status_1.Status.Forbidden,
        detail: "The email provided is not eligible for an account with Syla.",
    },
    [ProblemCode_1.ProblemCode.UserEmailNotFound]: {
        status: Status_1.Status.Unauthorized,
        detail: "User does not exist.",
    },
    [ProblemCode_1.ProblemCode.UserHasNoPassword]: {
        status: Status_1.Status.BadRequest,
        detail: "The user has no current password to check against.",
    },
    [ProblemCode_1.ProblemCode.IncorrectPassword]: {
        status: Status_1.Status.BadRequest,
        detail: "Password entered is incorrect.",
    },
    [ProblemCode_1.ProblemCode.SamePassword]: {
        status: Status_1.Status.BadRequest,
        detail: "The new password can't be the same as the old password.",
    },
    [ProblemCode_1.ProblemCode.CannotDeleteLastAccount]: { status: Status_1.Status.Conflict },
    [ProblemCode_1.ProblemCode.AlreadyInProgress]: { status: Status_1.Status.Conflict },
    [ProblemCode_1.ProblemCode.ExpiredLink]: { status: Status_1.Status.NotFound },
    [ProblemCode_1.ProblemCode.InviteExpired]: { status: Status_1.Status.Unauthorized },
    [ProblemCode_1.ProblemCode.InviteInvalid]: { status: Status_1.Status.NotFound },
    [ProblemCode_1.ProblemCode.InvitePasswordRequired]: { status: Status_1.Status.BadRequest },
    [ProblemCode_1.ProblemCode.UserAlreadyHasAccess]: {
        status: Status_1.Status.BadRequest,
        detail: "User already has access to the account.",
    },
    [ProblemCode_1.ProblemCode.UserInviteNotFound]: {
        status: Status_1.Status.BadRequest,
        detail: "No user with that email has been invited to the account.",
    },
    [ProblemCode_1.ProblemCode.AccountMustHaveOwner]: {
        status: Status_1.Status.BadRequest,
        detail: "Account must have at least one Owner user.",
    },
    [ProblemCode_1.ProblemCode.SubscriptionAlreadyExists]: {
        status: Status_1.Status.Conflict,
        detail: "An active subscription already exists for this account.",
    },
    [ProblemCode_1.ProblemCode.UnsupportedFileType]: {
        status: Status_1.Status.UnsupportedMediaType,
        detail: "The file provided is not supported.",
    },
    [ProblemCode_1.ProblemCode.ExceededRecordLimit]: {
        status: Status_1.Status.BadRequest,
    },
    [ProblemCode_1.ProblemCode.FailedFileImport]: {
        status: Status_1.Status.BadRequest,
    },
    [ProblemCode_1.ProblemCode.InvalidCustomFileTemplate]: {
        status: Status_1.Status.BadRequest,
    },
    [ProblemCode_1.ProblemCode.ValidateKeysFailed]: {
        status: Status_1.Status.BadRequest,
    },
    [ProblemCode_1.ProblemCode.ResourceLocked]: {
        status: Status_1.Status.Locked,
    },
};
